(($)=>{
    "use strict";

	const footerPosition = $( '.site-footer' ).offset().top;

	$(window).on('scroll', function() {
		if ( $(this).scrollTop() > $(window).height() && $(this).scrollTop() < ( footerPosition - $(window).height() / 2 - 100 ) ) {
			$( '.up.smooth-up' ).fadeIn(300);
		} else {
			$( '.up.smooth-up' ).fadeOut(300);
		}
	});

    $('.up.smooth-up').on('click', function(event) {
        event.preventDefault();
		$('html, body').stop().animate({scrollTop: 0}, 500, 'swing');
    });

})(jQuery)